import { FC, ReactElement, ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { MplButton, VerificationAnim } from '@mopla/ui';
import { FormTitle } from '@mopla/ui/layouts/WelcomeScreen';
import { usePersistentCountdownGuard } from '@mopla/utils';

interface IVerifyScreenProps {
	onResendEmail(): void | Promise<void>;
	render: (p: { content: ReactNode; submit: ReactNode }) => ReactElement;
}

export const VerifyReminderScreen: FC<IVerifyScreenProps> = ({
	onResendEmail,
	render,
}) => {
	const { t } = useTranslation('verifyReminder');
	const { countdownGuardValue } = usePersistentCountdownGuard('emailSendTime');
	const [isLoading, setLoading] = useState(false);

	const handleResendEmail = async () => {
		setLoading(true);

		await onResendEmail();

		setLoading(false);
	};

	return render({
		content: (
			<Stack className="content">
				<VerificationAnim />
				<FormTitle testId="registration-pleaseVerify-text">
					{t('text.title1')}
				</FormTitle>
				<Typography
					variant="b2"
					marginTop={3}
					color="solutions.600"
					textAlign="center"
					sx={{ whiteSpace: 'pre-line' }}
				>
					{t('text.title2')}
				</Typography>
			</Stack>
		),
		submit: (
			<MplButton
				fullWidth
				testId="welcomeScreen-verifyReminder-sendAgain-button"
				color="primaryButtonV2"
				onClick={handleResendEmail}
				disabled={!!countdownGuardValue}
				showLoader={isLoading}
			>
				{t('text.send_again', {
					context: countdownGuardValue ? 'wait' : undefined,
					time: countdownGuardValue,
				})}
			</MplButton>
		),
	});
};
